(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('verifytx-credential', {
                parent: 'entity',
                url: '/verifytx-credential',
                data: {
                    authorities: [],
                    pageTitle: 'VerifytxCredentials'
                },
                ncyBreadcrumb: {
                    label: 'VerifyTX Credential'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/verifytx-credential/list/verifytx-credential.html',
                        controller: 'VerifytxCredentialController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
